import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form } from "antd";
import { EExtendsMergeStrategy, EUserRole, ServiceTemplateField, TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { ServiceCodeEditorTip } from "./service-code-editor-tip.js";
import { useTranslation } from "../../../../../../others/i18n.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { validateScriptVariables } from "../../../../../../util/template/validation.js";
import { CodeMirrorWrapper } from "../../../../../third-party/code-mirror-wrapper.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
function FormFieldServiceTemplateCodeOptIn() {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ServiceTemplateField.CodeOptIn,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(ServiceTemplateField.CodeOptIn, t),
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                let mergedDynamicFields = getFieldValue(ServiceTemplateField.DynamicFields) || [];
                if ([
                    EExtendsMergeStrategy.Keep,
                    EExtendsMergeStrategy.Append
                ].includes(getFieldValue([
                    TemplateMetaDataField.ExtendedMergeStrategies,
                    ServiceTemplateField.DynamicFields
                ])) && extended?.dynamicFields) {
                    mergedDynamicFields = [
                        ...mergedDynamicFields,
                        ...extended.dynamicFields
                    ];
                }
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(ServiceCodeEditorTip, {}),
                        /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                            extendsFieldName: ServiceTemplateField.CodeOptIn,
                            disableStrategies: getDisableStrategies(),
                            onKeepContent: extended && /*#__PURE__*/ _jsx(CodeMirrorWrapper, {
                                options: {
                                    mode: "javascript",
                                    lineNumbers: true,
                                    readOnly: true
                                },
                                value: extended[ServiceTemplateField.CodeOptIn]
                            }),
                            children: /*#__PURE__*/ _jsx(Form.Item, {
                                dependencies: [
                                    ServiceTemplateField.DynamicFields
                                ],
                                name: ServiceTemplateField.CodeOptIn,
                                rules: [
                                    {
                                        validator: (_, value)=>{
                                            return validateScriptVariables(value, mergedDynamicFields, t);
                                        }
                                    }
                                ],
                                noStyle: true,
                                children: /*#__PURE__*/ _jsx(CodeMirrorWrapper, {
                                    options: {
                                        mode: "javascript",
                                        lineNumbers: true
                                    }
                                })
                            })
                        })
                    ]
                });
            }
        })
    });
}
export { FormFieldServiceTemplateCodeOptIn };
